<template>
  <div>
    <v-data-table
      class="pa-2"
      disable-pagination
      :headers="headers"
      :items="repeatServices"
      :pagination.sync="pagination"
      :hide-default-footer="true"
      dense
    >
      <template v-slot:item="props">
        <tr :class="{'borderBottom': props.item.trip_b == null}" :style="styleForItem(props.item, props.item.trip_a, props.index % 2 == 0, false)">
          <td>
            <v-row>
              <v-flex pb-1 pt-1 pr-2>
                <v-btn class="text-none" x-small ripple @click="editRepeatService(props.item)">View</v-btn>
              </v-flex>
            </v-row>
          </td>
           <td style="width:5%;">
            <div>
              <span>
                 {{ props.item.name }}
                <br />
                <p v-if="props.item.business_reference_number">{{props.item.business_reference_number}}</p>
              </span>
            </div>
          </td>
          <td>
            <div>
              <p v-if="props.item.user.name != null">{{props.item.user.name}}</p>
              <p v-if="props.item.lead_passenger_name != null">{{props.item.lead_passenger_name}}</p>
            </div>
          </td>
          <td v-html="numPeople(props.item.trip_a)" style="width:1%;"></td>
          <td v-html="dateRange(props.item.trip_a)" style="width:10%;"></td>
          <td v-html="timeRange(props.item.trip_a)" style="width:2%;"></td>
          <td style="width: 10%;">
            <div class="fixed-booking-table-row" >
              <p>{{pickup(props.item.trip_a)}}</p>
            </div>
          </td>
          <td style="width: 10%;" v-for="(v) in viaCount">
            <div
              class="fixed-booking-table-row"
              v-html="via(props.item.trip_a, v)"
            ></div>
          </td>
          <td style="width: 10%;">
            <div
              class="fixed-booking-table-row"
              v-html="destination(props.item.trip_a)"
            ></div>
          </td>
          <td style="width:10%">
            <p v-html="preassignedDriver(props.item.trip_a)" >     
              </p>
          </td>
          <td style="width:10%">
            <p v-html="driverNotes(props.item.trip_a)" >     
              </p>
          </td>
          <td style="width:2%">
            <p>{{driverCost(props.item.trip_a)}}</p>
          </td>
        </tr>
        <!-- BREAK FOR TRIP B -->
        <tr :class="{'borderBottom': props.item.trip_b != null}" :style="styleForItem(props.item, props.item.trip_b, props.index % 2 == 0, true)" v-if="props.item.trip_b != null">
            <td>
            <v-row>
           
            </v-row>
          </td>
           <td style="width:5%;">
            <div>
             
            </div>
          </td>
          <td>
            <div>
              <p v-if="props.item.user.name != null">{{props.item.user.name}}</p>
              <p v-if="props.item.lead_passenger_name != null">{{props.item.lead_passenger_name}}</p>
            </div>
          </td>
          <td v-html="numPeople(props.item.trip_b)" style="width:1%;"></td>
          <td v-html="dateRange(props.item.trip_b)" style="width:10%;"></td>
          <td v-html="timeRange(props.item.trip_b)" style="width:2%;"></td>
          <td>
            <div class="fixed-booking-table-row" >
              <p>{{pickup(props.item.trip_b)}}</p>
            </div>
          </td>
          <td style="width: 10%;" v-for="(v) in viaCount">
            <div
              class="fixed-booking-table-row"
              v-html="via(props.item.trip_b, v)"
            ></div>
          </td>
          <td>
            <div
              class="fixed-booking-table-row"
              v-html="destination(props.item.trip_b)"
            ></div>
          </td>
          <td style="width:10%">
            <p v-html="preassignedDriver(props.item.trip_b)" >     
              </p>
          </td>
          <td style="width:10%">
            <p v-html="driverNotes(props.item.trip_b)" >     
              </p>
          </td> 
          <td style="width:2%">
            <p>{{driverCost(props.item.trip_b)}}</p>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

import AttributesForBookingCell from "@/components/widget/AttributesForBookingCell.vue";

export default {
  name: "repeat_service_list",
  components: {
    ViasForBooking,
    AttributesForBookingCell
  },
  props: {
    repeatServices: Array,
    paginationProp: Object,
  },
  mounted: async function () {},
  data: function () {
    return {
      message: "",
      pagination: this.paginationProp,
      viaCount: 0,
    }
  },
  computed: {
    headers: function() {
      var headers =  [
         {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "name",
          width: "72px",
        },
        {
          text: "Ref",
          align: "left",
          sortable: false,
          value: "id",
          width: "50px",
        },
        {
          text: "Customer",
          align: "left",
          sortable: false,
          value: "name",
          width: "70px",
        },
        {
          text: "PAX",
          align: "left",
          sortable: false,
          value: "num_people",
          width: "50px",
        },
        {
          text: "Date",
          align: "left",
          sortable: false,
          value: "date",
          width: "140px",
        },
        {
          text: "Time",
          align: "left",
          sortable: false,
          value: "num_people",
          width: "50px",
        },
        {
          text: "Pickup",
          align: "left",
          sortable: false,
          value: "pickup",
          width: "270px",
        },
      ];

      var viaCount = 0;

      for (var i = 0; i < this.repeatServices.length; i++) {

        let rs = this.repeatServices[i];
        
        if (rs.trip_a != null && rs.trip_a.repeat_trip_template != null) {
          var length = rs.trip_a.repeat_trip_template.destinations.length;

          if ((length - 1) > viaCount) {
            viaCount = length - 1;
          }
        }

        if (rs.trip_b != null && rs.trip_b.repeat_trip_template != null) {
          var length = rs.trip_b.repeat_trip_template.destinations.length;

          if ((length - 1) > viaCount) {
            viaCount = length - 1;
          }
        }
      }

      for (var i = 0; i < viaCount; i++) {
        headers.push(  {
          text: "Via " + (i+1),
          align: "left",
          sortable: false,
          value: "via_" + (i+1),
          width: "270px",
        },);
      }

      this.viaCount = viaCount;

      headers.push(  {
          text: "Destination",
          align: "left",
          sortable: false,
          value: "destinations",
          width: "270px",
        },
        {
          text: "Driver",
          align: "left",
          sortable: false,
          value: "driver",
          width: "50px",
        },
       {
          text: "Notes",
          align: "left",
          sortable: false,
          value: "driver",
          width: "50px",
        },
        {
          text: "Driver Cost",
          align: "left",
          sortable: false,
          value: "£",
          width: "50px",
        },
       );

      return headers;

    },
  },
  methods: {
    styleForItem(rs, item, odd, isTripB) {
      if (rs != null) {
          if (item) {
            if (!item.repeat_trip_template.preassigned_driver) {
              return {
                backgroundColor: "#f19696",
                borderBottom: "1pt solid black !important;"
              }
            }
          }
      }

      if (odd) {
        return {
          backgroundColor: "#F9F9FC",
          borderBottom: isTripB ? "1pt solid black !important;" : ""
        }
      } else {
        return {
          backgroundColor: "white",
          borderBottom: isTripB ? "1pt solid black !important;" : ""
        }
      }
    },
    driverCost: function(b) {
       if (b == null || b.repeat_trip_template == null) {
        return "";
      }
      
      if (b.repeat_trip_template.fixed_cost_driver != null && b.repeat_trip_template.fixed_cost_driver != 0) {
        return (b.repeat_trip_template.fixed_cost_driver / 100.0).toFixed(2);
      }

      if (b.repeat_trip_template.final_cost) {
        if (b.repeat_trip_template.final_cost_driver) {
          return (b.repeat_trip_template.final_cost_driver / 100.0).toFixed(2);
        }
      }
      
      return ""
     
    },
    preassignedDriver: function(b) {
      
      if (b == null || b.repeat_trip_template == null || b.repeat_trip_template.preassigned_driver == null) {
        return "";
      }
      
      return "<b>" + b.repeat_trip_template.preassigned_driver.driver.callsign + "</b>&nbsp;&nbsp;" + b.repeat_trip_template.preassigned_driver.driver.name;
     },
     driverNotes: function(b) {
      
      if (b == null || b.repeat_trip_template == null || b.repeat_trip_template.message == null) {
        return "";
      }
      
      return b.repeat_trip_template.message;
     },
     destination: function( b ) {
      
      if (b == null) {
        return null;
      }

      var booking = b.repeat_trip_template;

      if (booking.destinations != null && booking.destinations.length > 0) {
        return booking.destinations[0].description;
      } 

      return "";
    },
    via: function(b, index) {

      if (b == null) {
        return null;
      }
      
      
      var booking = b.repeat_trip_template;

      if (booking == null) {
        return "";
      }
 
      if (booking.destinations != null && booking.destinations.length > 0) {

        if ((index) >= (booking.destinations.length)) {
          return ""
        }

        var vias = "";

        var passengerInfo = null;
        
        let viasOnly = booking.via_info
        
        if (booking.pickup_info) {
          viasOnly = []
          if (booking.via_info) {
            booking.via_info.forEach(via => {
              if (via.id != booking.pickup_info.id)  {
                viasOnly.push(via)
              }
            })
          }
        }

        if (booking.via_info != null) {
          if (index - 1 <= viasOnly.length -1) {
            passengerInfo = viasOnly[index - 1].name;
          }
          
/*
          for (var i = 0; i < viasOnly.length; i++) {
            if (i == index) {
              passengerInfo = viasOnly[i].name;
            }
          }
*/
        }

        if (passengerInfo != null && passengerInfo != "") {
          vias += "<b>" + passengerInfo + "</b><br>"
        }
        
        let destinations = [];
        booking.destinations.forEach(d => {
          if (d.id != booking.destinations[0].id) {
            destinations.push(d)
          }
        })

        return vias + destinations[index -1].description;
      } 

      return "";
    },
    pickup: function( b ) {
      
      if (b == null) {
        return null;
      }

      var booking = b.repeat_trip_template;

      return booking.pickup_location.description;
    },
    editRepeatService: function (item) {
      this.$emit("edit", item);
    },
    numPeople: function(b) {
      
      if (b == null) {
        return null;
      }

      var booking = b.repeat_trip_template;

      if (booking.num_people == null) {
        return ""
      }

      if (booking.num_people > 4) {
        return '<div class="circle">' + booking.num_people + "</div>"
      } else {
        return '<div class="center">' + booking.num_people + "</div>";
      }
    },
    dateRange: function(service) {

      if (service == null) {
        return "";
      }

      if (service.date_span.start_date == null) {
        return "";
      }

      if (service.date_span.end_date == null) {
        return service.date_span.end_date;
      }

      return service.date_span.start_date + " - " + service.date_span.end_date 
    },
    timeRange: function(service) {
      
      if (service == null) {
        return "";
      }

      if (service.day_of_week_times_list == null || service.day_of_week_times_list.length == 0) {
        return "";
      }

      return service.day_of_week_times_list[0].time;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px !important;
}

// .fixed-booking-table-row {
//   overflow: hidden;
//   height: 24px;
// }

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 4px !important;
  border: none;
}

table.v-table tbody td {
  height: 40px;
  border: none;
}
.theme--light.v-table tbody tr:not(:last-child) {
  border-bottom: none;
}


thead th:not(:first-child) {
  padding: 0 8px;
}

.v-data-table td {
  font-size: 11px !important;
  height: 19px;
}

.v-data-table th {
  font-size: 11px !important;
  height: 19px;
}

.circle {
  width: 16px;
  height: 16px;
  line-height: 15px;
  border-radius: 50%;
  background: #FFBB96;
  text-align: center;
}

td {
  line-height: 1.1;
}

.v-data-table td, .v-data-table th {
    padding: 0 2px !important;
        padding-top: 0px;
        padding-bottom: 0px;
    padding-top: 2px !important;
    padding-bottom: 2px !important;
}

tr.borderBottom td {
  border-bottom: 1px solid black !important;
}

</style>
